import mergeClasses from 'shared/lib/utils';
import { projectStatus } from '@/enteties/project/lib/project-status';
import { TooltipWrapper } from 'shared/ui/tooltips';
import type { ProjectStatus } from '@/enteties/project/modal';
interface StatusChipProps {
  status: ProjectStatus;
}
export function StatusChip({
  status
}: StatusChipProps) {
  return <TooltipWrapper content={projectStatus[status]?.hint ?? 'Обратитесь в техподдержку для решения проблемы'} data-sentry-element="TooltipWrapper" data-sentry-component="StatusChip" data-sentry-source-file="status-chip.tsx">
      <div className={mergeClasses('h-[22px] rounded-[0.625rem] px-2 border inline-flex items-center justify-center', projectStatus[status]?.color)}>
        <p className="align-middle text-body3 line-clamp-1">
          {projectStatus[status]?.message}
        </p>
      </div>
    </TooltipWrapper>;
}